// app/page.tsx
'use client';

import { useRouter } from 'next/navigation';
import React, { Suspense, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { generateRoomId } from '@/lib/client-utils';
import { VideoIcon } from '@/components/meetx/Icons';
import { HomeIcon } from '@/components/dashboard/Icons';
import { useAuth } from '@/lib/context/AuthContext';
import toast from 'react-hot-toast';
import styles from './meetx-home.module.css';

function HomeContent() {
  const router = useRouter();
  const { user, loading } = useAuth();
  const [joinCode, setJoinCode] = useState('');

  function startMeeting() {
    if (!loading && !user) {
      toast.error('Anda belum login. Silakan login terlebih dahulu.');
      setTimeout(() => {
        router.push('/login');
      }, 1500);
      return;
    }
    router.push(`/rooms/${generateRoomId()}?create=true`);
  }

  function joinMeeting() {
    const code = joinCode.trim();
    if (!code) return;
    const roomName = code.replace(/^.*\/rooms\//, '').replace(/^.*\/join\//, '');
    router.push(`/rooms/${roomName}`);
  }

  return (
    <main className={`mx-theme-dark ${styles.main}`}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <Image src="/images/logo.png" alt="PRIMA Virtual Meeting" width={140} height={40} className={styles.logoImg} />
          </div>
          <div className={styles.headerActions}>
            {!loading && user ? (
              <Link href="/home" className={`mx-btn mx-btn--secondary ${styles.headerLink}`}>
                <HomeIcon size={18} /> Dashboard
              </Link>
            ) : (
              <Link href="/login" className={`mx-btn mx-btn--secondary ${styles.headerLink}`}>
                <HomeIcon size={18} /> Login
              </Link>
            )}
          </div>
        </header>

        <div className={styles.heroContent}>
          <section className={styles.textSection}>
            <h1 className={styles.headline}>
              PRIMA <br />Virtual Meeting
            </h1>

            <div className={`mx-card ${styles.actionCard}`}>
              <button className="mx-btn mx-btn--primary mx-btn--lg mx-btn--block" onClick={startMeeting}>
                <VideoIcon size={20} /> Rapat Baru
              </button>

              <div className={styles.divider}>
                <span>atau gabung dengan kode</span>
              </div>

              <div className={styles.inputGroup}>
                <input
                  className={`mx-input ${styles.joinInput}`}
                  placeholder="Masukkan kode atau tautan rapat…"
                  value={joinCode}
                  onChange={(e) => setJoinCode(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && joinMeeting()}
                />
                <button className="mx-btn mx-btn--secondary" onClick={joinMeeting}>
                  Gabung
                </button>
              </div>
            </div>
          </section>

          <section className={styles.illustrationSection}>
            <div className={styles.heroImageWrapper}>
              <Image
                src="/images/mabes_tni.png"
                alt="Logo TNI"
                width={300}
                height={300}
                className={styles.heroImage}
                priority
              />
            </div>
          </section>
        </div>

        <footer className={styles.footer}>
          Powered by <a href="https://satkomlek-tni.mil.id/" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>SATKOMLEK TNI</a>
        </footer>
      </div>
    </main>
  );
}

import { AuthProvider } from '@/lib/context/AuthContext';

export default function Page() {
  return (
    <AuthProvider>
      <Suspense>
        <HomeContent />
      </Suspense>
    </AuthProvider>
  );
}
